export function getCurrencyDisplayLabel(codeOrName: string | undefined): string {
  if (!codeOrName) return "";
  if (codeOrName === "BRL" || codeOrName === "Brazilian Real") {
    return "Real Brasileiro";
  }
  return codeOrName;
}

export function mapCurrencyOptions<T extends { code: string; name: string }>(data: T[]) {
  return data.map((el) => ({ value: el.code, label: getCurrencyDisplayLabel(el.name) }));
}